import axios from 'axios';

export default {
    data() {
        return {
            image_path: 'https://show.guyanalive.com/',
            youtubeBase: 'https://www.googleapis.com/youtube/v3/search',
            youtubeKey: 'AIzaSyBnsVnqQ2qHRyXSu8ZJRXM4Tbxn2lQatQI&channelId=UC4tUadsFU_-rLzYD7UxHFEg',
            sliderDataAction: '[{"event":"click","action":"simplelink","target":"_self","url":"#"}]',
            albums: [],
            errors: [],
            videos: [],
            currentVideo: null,
            playerVars: {
                autoplay: 1,
            },
        };
    },

    // Fetches posts when the component is created.
    created() {
        window.scrollTo(0, 0);
        axios
            .get('https://show.guyanalive.com/index.php?album=Parties&json')
            .then((response) => {
                // JSON responses are automatically parsed.
                this.albums = response.data.album.albums;
            })
            .catch((e) => {
                this.errors.push(e);
            });
        this.getVideos();
    },
    methods: {
        getVideos() {
            axios
                .get(
                    `${this.youtubeBase}?key=${this.youtubeKey}&part=snippet,id&order=date&maxResults=3`,
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.videos = response.data.items;
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        truncate(string) {
            if (string.length > 40) {
                return `${string.substring(0, 40)}...`;
            } else {
                return string;
            }
        },
        playing() { },
    },
    mounted() {
        // Force main slider to display on router navigate
        if (window.$('#main-slider').length > 0) {
            window.jQuery('#main-slider').revolution({
                sliderType: 'hero',
                sliderLayout: 'fullscreen',
                delay: 6000,
                gridwidth: 1230,
                gridheight: 950,
                parallax: {
                    type: 'mouse',
                    origo: 'slidercenter',
                    speed: 2000,
                    levels: [2, 3, 4, 5, 6, 7, 12, 16, 10, 50],
                },
                navigation: {
                    arrows: {
                        enable: false,
                    },
                },
            });
        }
    },
};



// WEBPACK FOOTER //
// ./src/components/main/main.page.js